import { render, staticRenderFns } from "./rop.vue?vue&type=template&id=2fe77cd8"
import script from "./rop.vue?vue&type=script&lang=js"
export * from "./rop.vue?vue&type=script&lang=js"
import style0 from "./rop.vue?vue&type=style&index=0&id=2fe77cd8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports